export default "__VITE_ASSET__DD73GgU1__"